// extracted by mini-css-extract-plugin
export default {"container":"profile_container__TFx3H","cell":"profile_cell__GpXRC","update":"profile_update__yV2QD","degree-list":"profile_degree-list__V2J3Q"};